var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { Currency } from '@increasecard/increase-core';
import { BoxShape as BaseBoxShape } from './BoxShape';
var BoxShape = styled(BaseBoxShape)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px solid ", ";\n"], ["\n  border: 1px solid ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorsNew.gray.subtleBorder;
});
var STYLES_BY_VARIANT = {
    light70: {
        titleColor: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), function (_a) {
            var theme = _a.theme;
            return theme.colorsNew.product.dark70;
        }),
        valueColor: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), function (_a) {
            var theme = _a.theme;
            return theme.colorsNew.product.dark70;
        }),
        background: function (_a) {
            var theme = _a.theme;
            return theme.colorsNew.product.light70;
        }
    },
    dark30: {
        titleColor: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), function (_a) {
            var theme = _a.theme;
            return theme.colorsNew.product.light70;
        }),
        valueColor: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), function (_a) {
            var theme = _a.theme;
            return theme.colorsNew.gray.white;
        }),
        background: function (_a) {
            var theme = _a.theme;
            return theme.colorsNew.product.dark30;
        }
    },
    white: {
        titleColor: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), function (_a) {
            var theme = _a.theme;
            return theme.colorsNew.product.dark;
        }),
        valueColor: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), function (_a) {
            var theme = _a.theme;
            return theme.colorsNew.product.dark50;
        }),
        background: function (_a) {
            var theme = _a.theme;
            return theme.colorsNew.gray.white;
        },
        titleFontWeight: 'regular'
    },
    coralSLight: {
        titleColor: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), function (_a) {
            var theme = _a.theme;
            return theme.colorsNew.coral.dark;
        }),
        valueColor: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), function (_a) {
            var theme = _a.theme;
            return theme.colorsNew.coral.dark;
        }),
        background: function (_a) {
            var theme = _a.theme;
            return theme.colorsNew.coral.sLight;
        }
    }
};
var Title = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", ";\n  font-weight: ", ";\n  color: ", ";\n"], ["\n  ", ";\n  font-weight: ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.H2;
}, function (_a) {
    var fontWeight = _a.fontWeight;
    return fontWeight || 'bold';
}, function (_a) {
    var textColor = _a.textColor;
    return textColor;
});
var Value = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", ";\n  font-weight: bold;\n  color: ", ";\n"], ["\n  ", ";\n  font-weight: bold;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.H1;
}, function (_a) {
    var textColor = _a.textColor;
    return textColor;
});
export function NumberBox(_a) {
    var currency = _a.currency, title = _a.title, value = _a.value, variant = _a.variant;
    var styles = STYLES_BY_VARIANT[variant];
    return (React.createElement(BoxShape, { bgColor: styles.background },
        title && (React.createElement(Title, { fontWeight: styles.titleFontWeight, textColor: styles.titleColor }, title)),
        React.createElement(Value, { textColor: styles.valueColor }, value !== undefined ? React.createElement(Currency, { currency: currency, value: value }) : '...')));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
